<template>
  <div>
    <b-link class="newsLink" @click="openLink();">
      <div class="mx-3">
        <!--
        <b-img
          
          blank-color="#C8C3C2"
          style="width:100%; height: 220px; border-radius: 1rem;"
          :src="data.image"
        />
        -->
        <div :style="'width:100%; height: 220px; border-radius: 1rem; background: url(\''+data.image+'\'); background-size: cover; background-position: center;'" />
        <div
          style="font-family: 'Poppins', sans-serif; font-size: x-small; margin-top: 1rem; margin-bottom: .5rem; color: rgba(0,0,0,.5);"
        >
          {{data.publishdate}}
        </div>
        <div style="font-weight: bold; line-height: 1.3em; margin-bottom: .5rem;">
          <span v-html="data.title"></span>
        </div>
        <div class="clip" style="font-size: small; height: 3.5rem; overflow: hidden;">
          <span v-html="data.description"></span>
        </div>
      </div>
    </b-link>
    <b-badge class="m-1 p-2" v-for="book in books" :key="'b' + book.id" :to="'/detalles/' + book.id">
            {{book.lbl}}
    </b-badge>
    <b-badge class="m-1 p-2" v-for="author in authors" :key="'a' + author.id" :to="'/autoresdetail/' + author.id">
            {{author.lbl}}
    </b-badge>
  </div>
</template>
<script>
export default {
  props: ["data"],
  computed:{
    books(){
      const booklist = [];
      if (this.data.books){
        const parseBookList = this.data.books.split(',');
        parseBookList.forEach(element => {
          if (element !== ''){
            const parseBookItem = element.split('|');
            booklist.push({id: parseBookItem[0], lbl: parseBookItem[1]})
          }
        });
      }
      
      return booklist;
      
    },
    authors(){
      const authorlist = [];
      if (this.data.authors){
        const parseAuthorList = this.data.authors.split(',');
        parseAuthorList.forEach(element => {
          if (element !== ''){
            const parseAuthorItem = element.split('|');
            authorlist.push({id: parseAuthorItem[0], lbl: parseAuthorItem[1]})
          }
        });
      }
      
      return authorlist;
    }
  },
  methods:{
    openLink(){
      if (this.data.internal === "1"){
        this.$router.push("/noticias/detalle/" + this.data.id);
      }else{
        window.open(this.data.url, '_blank');
      }
    }
  }
}
</script>